// extracted by mini-css-extract-plugin
module.exports = {"container":"IV","imgContainer":"JV","content":"KV","brand":"LV","product":"MV","price":"NV","noLink":"OV"};